module.exports = __webpack_public_path__ + "img/bg.b1525a97.png";